export default __webpack_public_path__ + "static/media/WinterBook_03.969044bb.png";